import Axios from "axios"

/*
 * A base Axios client for node endpoints in the /pages/api folder within this app
 */

const API = Axios.create({
    baseURL: "/api",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
})

export default API
